import { memo } from 'react'

import { useDispatch, useSelector } from '@tabeeb/store'
import { feedbackInContentReviewRequest } from '@tabeeb/modules/contentReviews/actions'
import { getContentId } from '@tabeeb/modules/shared/content/selectors'
import { getFormButtonState } from '@tabeeb/modules/forms/selectors'
import { Button } from '@collaborate-health/uikit'

import { FormButtons } from '../../services/enums'

const SendInContentReviewFeedbackButton: React.FC = () => {
  const dispatch = useDispatch()

  const contentId = useSelector(getContentId)
  const { isVisible, isDisabled } = useSelector((state) =>
    getFormButtonState(state, { button: FormButtons.FeedbackInContentReview })
  )

  if (!isVisible) {
    return null
  }

  return (
    <Button
      onClick={() => dispatch(feedbackInContentReviewRequest({ contentId }))}
      variant='contained'
      color='primary'
      size='small'
      disabled={isDisabled}
      fullWidth
    >
      Send Feedback
    </Button>
  )
}

export default memo(SendInContentReviewFeedbackButton)

